import { useState } from "react";
import { Row, Col } from "reactstrap";
import { Button, Spin } from "antd";
import Lottie from "lottie-react";
import lockAnim from "../../../assets/animations/lock.json";
import alert from "../../../assets/animations/Alert.json";
import mailAnim from "../../../assets/animations/mailAnimation.json";
import toast from "react-hot-toast";

import OtpInputBlock from "./OtpInput";
import useCountdown from "../../hooks/useCountdown";
import { DiasableQRCode, verifyQRCodeAuth} from "../../../modules/auth/services/otpApi";

import "../authenti.css";

const Disable2FA = ({ username, twoFaEnabled }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [step, setStep] = useState(1);

  const countdown = useCountdown(30);

  const handleVerify = async () => {
    setLoading(true);
    try {
      const res = await verifyQRCodeAuth({ username, code: otp });
      if (res?.statusCode === 200) {
        setStep(2);
      } else {
        setError(res?.message || "Code invalide");
      }
    } catch (e) {
      toast.error("Erreur lors de la vérification.");
    }
    setLoading(false);
  };

  const handleDisableByEmail = async () => {
    setLoading(true);
    try {
      const frontendUrl = process.env.REACT_APP_CLIENT_URL;
      const resp = await DiasableQRCode({ username, frontendUrl });
      console.log('resp', resp)
      if (resp?.statusCode===200){
        setStep(3);
        toast.success("Vérifie ta boîte mail pour finaliser.");
      } else {
        setError(resp?.message)
      }   
      
    } catch (e) {
      toast.error("Échec de la désactivation.");
    }
    setLoading(false);
  };

  if (!twoFaEnabled) {
    return (
      <div className="text-center mt-4">
        <div style={{ width: 100, margin: "0 auto", marginBottom: 30 }}>
          <Lottie animationData={alert} loop autoplay />
        </div>

        <div className="twofa-badge-disable">
          <span className="dot-red"></span>
            2FA désactivé
          <span className="check-red">✖</span>
        </div>

        <p className="twofa-info mt-4">
          Pour sécuriser vos transactions, vous pouvez l'activer en haut à droite.
        </p>
      </div>
    );
  }

  if (step === 2 || step === 3) {
    const isStep3 = step === 3;

    return (
      <div className="text-center mt-4">
        {error && <div className="alert alert-danger">{error}</div>}

        <Lottie
          animationData={mailAnim}
          loop
          autoplay
          style={{ width: 150, margin: "0 auto", marginBottom: 20 }}
        />

        <p className="mb-2">
          {isStep3 ? "Email de réinitialisation envoyé." : "Chez Paxity, on priorise la sécurité."}
        </p>
        {!isStep3 && (
          <p className="mb-3">
            Un email de réinitialisation vous sera envoyé. <br />
            Suivez la procédure et revenez scanner à nouveau.
          </p>
        )}

        <div className="d-flex justify-content-center gap-2 mt-4">
          {!isStep3 && (
            <>
              <Button onClick={() => setStep(1)} disabled={loading}>
                Annuler
              </Button>
              <Button type="primary" onClick={handleDisableByEmail} disabled={loading}>
                {loading ? <Spin size="small" /> : "Réinitialiser"}
              </Button>
            </>
          )}
          {isStep3 && (
            <Button type="primary" onClick={() => (window.location.href = "/dashboard")}>
              Retour en accueil
            </Button>
          )}
        </div>
      </div>
    );
  }


  return (
    <Row className="double-step1 mt-4">
      {error && <div className="alert alert-danger">{error}</div>}

      <Col lg={6} className="double-qr-section text-center mt-4">
        <h6 className="double-qr-title mb-3">Désactivation 2FA</h6>

        <div className="double-qr-container">
          <div className="double-loading-state">
            Vous avez déjà scanné le QR Code.
          </div>     
          <p className="double-qr-text mt-4 ">
            Saisissez et Suivez la procédure pour confirmer la désactivation.
          </p>
          <p className="double-qr-text-disable mt-0 mb-4">
            <em><strong>NB : </strong> La désactivation peut réduire la sécurité de vos transactions.</em>
          </p>
        </div>

        {/* <Button
          type="primary"
          className="double-rescan-link"
          onClick={() => setStep(2)}
        >
          Je scanne à nouveau
        </Button> */}
      </Col>

      <Col lg={1} className="double-divider-col">
        <div className="double-vertical-divider" />
      </Col>

      <Col lg={5} className="double-otp-section text-center">
        <div style={{ width: 80, margin: "0 auto", marginBottom: 20 }}>
          <Lottie animationData={lockAnim} loop autoplay />
        </div>

        <div
          className={`double-otp-timer mb-4 ${
            countdown <= 10 ? "red" : "default"
          }`}
        >
          Le code est généré chaque 30s
        </div>

        <OtpInputBlock otp={otp} setOtp={setOtp} />

        <Button
          type="primary"
          onClick={handleVerify}
          disabled={loading}
          className="double-confirm-button mt-4"
        >
          {loading ? <Spin size="small" /> : "Désactiver"}
        </Button>
      </Col>
    </Row>
  );
};

export default Disable2FA;
